import { SolutionPriceContainer } from '../Types/MatchingProducts.ts';

export const setPricePLP = (
  productListItemElement: HTMLDivElement,
  priceContainer: SolutionPriceContainer | null | undefined
) => {
  if (!priceContainer || !productListItemElement) return;

  let priceElement = productListItemElement.querySelector('.price-value');
  if (!priceElement) return;

  const savingsElement: HTMLSpanElement | null = productListItemElement.querySelector('.discount-price--saved');
  if (savingsElement) savingsElement.innerHTML = '';

  if (window._THULEDATA?.isExtranet) {
    let rrpElement: HTMLSpanElement = productListItemElement.querySelector('.RRP-value') as HTMLSpanElement;
    if (rrpElement) rrpElement.innerHTML = priceContainer.PriceFormatted;
    priceElement.innerHTML = '';
  } else {
    let discountPriceElement: HTMLSpanElement = productListItemElement.querySelector(
      '.discount-price-value'
    ) as HTMLSpanElement;
    if (!discountPriceElement) return;

    if (priceContainer.DiscountPrice > 0) {
      priceElement.innerHTML = priceContainer.PriceFormatted;
      discountPriceElement.innerHTML = priceContainer.DiscountPriceFormatted;
      priceElement.classList.add('discounted');
      if (savingsElement && priceContainer.Save) savingsElement.innerHTML = `(${priceContainer.Save})`;
    } else {
      priceElement.innerHTML = priceContainer.PriceFormatted;
      discountPriceElement.innerHTML = '';
      priceElement.classList.remove('discounted');
    }
  }
};

export const resetPricePLP = (productListItemElement: HTMLDivElement) => {
  if (!productListItemElement) return;

  if (window._THULEDATA?.isExtranet) {
    const rrpElement: HTMLSpanElement | null = productListItemElement.querySelector('.RRP-value');
    if (rrpElement) rrpElement.innerHTML = rrpElement.dataset.defaultprice ?? '';
    return;
  }

  const priceElement: HTMLSpanElement | null = productListItemElement.querySelector('.price-value');
  if (priceElement) {
    priceElement.classList.remove('discounted');
    priceElement.innerHTML = priceElement.dataset.defaultprice ?? '';
  }

  const discountPriceElement: HTMLSpanElement | null = productListItemElement.querySelector('.discount-price-value');
  if (discountPriceElement) discountPriceElement.innerHTML = discountPriceElement.dataset.defaultprice ?? '';

  const savingsElement: HTMLSpanElement | null = productListItemElement.querySelector('.discount-price--saved');
  if (savingsElement) savingsElement.innerHTML = savingsElement.dataset.defaultprice ?? '';
};
